"use client";

import { usePathname } from "next/navigation";
import type React from "react";
import { useMemo } from "react";
import { isPublicRoute } from "@/lib/route-config";

interface NavigationEventsProps {
  children: React.ReactNode;
  protectedLayout: React.ReactNode;
}

export function NavigationEvents({
  children,
  protectedLayout,
}: NavigationEventsProps) {
  const pathname = usePathname();

  const isPublic = useMemo(() => isPublicRoute(pathname), [pathname]);

  if (isPublic) {
    return <>{children}</>;
  }

  return <>{protectedLayout}</>;
}
